import { render, staticRenderFns } from "./EmailNotification.vue.js?vue&type=template&id=6270fc1a&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EmailNotification.vue?vue&type=template&id=6270fc1a&scoped=true"
import script from "./EmailNotification.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EmailNotification.vue?vue&type=script&lang=js"
export * from "./EmailNotification.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EmailNotification.vue?vue&type=script&lang=js"
import style0 from "./EmailNotification.vue.scss?vue&type=style&index=0&id=6270fc1a&prod&lang=scss&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EmailNotification.vue?vue&type=style&index=0&id=6270fc1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6270fc1a",
  null
  
)

export default component.exports